import { render } from "./TrainingTrainingPeriodHeadingComponent.vue?vue&type=template&id=1cfa644a&scoped=true"
import script from "./TrainingTrainingPeriodHeadingComponent.vue?vue&type=script&lang=js"
export * from "./TrainingTrainingPeriodHeadingComponent.vue?vue&type=script&lang=js"

import "./TrainingTrainingPeriodHeadingComponent.vue?vue&type=style&index=0&id=1cfa644a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfa644a"]])

export default __exports__